module.exports = __webpack_public_path__ + "img/yacht.4b5f2fb3.png";